// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.product-filter {
    .bopis-filter-redesign {
      border-bottom: 1px solid rgba(146, 146, 146, 0.4);
      @media ${(props) => props.theme.mediaQuery.large} {
        border-top: 1px solid rgba(146, 146, 146, 0.4);
        padding-top: 21px;
      }
      padding: 14px 0px 21px;
      .store-info {
        flex-direction: column;
        display: inline;
        font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      }
      .bopis-storename.mallName {
        text-transform: capitalize;
        font-weight: ${(props) => props.theme.typography.fontWeights.bold};
      }
      .store-change-wrapper {
        margin: 0;
        font-weight: bold;
      }
      .bopis-filter-wrapper {
        height: fit-content;
        display: inline-block;
        line-height: 1.5;
        margin-bottom: 0;
        padding-left: 10px;
        padding-right: 10px;
      }
      .switch-filter {
        display: inline;
        margin-right: 6px;
      }
    }
    .change-store-link {
      font-size: 14px;
      font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
    }
  }
`;
